export default {
    computed: {
        status() {
            return this.getStatus(this.item);
        }
    },
    methods: {
        getStatus(item) {
            if(!item) {
                return {color: 'error', icon:'$warn', text: 'No project' };
            }
            switch(item.active) {
                case 'ACTIVE': return {color: 'success', icon: '$ok', text: this.$t('domains.status.active'), active: true };
                case 'INCOMPLETE': return {color: 'warning', icon: '$nok', text: this.$t('domains.status.incomplete')};
                case 'OVER_LIMIT': return {color: 'error', icon: '$warn', text: this.$t('domains.status.overLimit')};
                case 'PAYMENT_DUE': return {color: 'error', icon:'$paymentDue', text: this.$t('domains.status.paymentDue')};
                case 'CANCELLED': return {color: 'error', icon:'$inactive', text: this.$t('domains.status.cancelled')};
                case 'PURGED': return {color: 'error', icon:'$purged', text: this.$t('domains.status.purged')};
                case 'BLOCKED_AUTOMATIC': return {color: 'error', icon:'$blocked', text: this.$t('domains.status.blockedAutomatic')};
                case 'BLOCKED_MANUAL': return {color: 'error', icon:'$blocked', text: this.$t('domains.status.blockedManual')};
                case 'MARKED_FOR_PURGE': return {color: 'warning', icon:'$purged', text: this.$t('domains.status.markedForPurge')};
                default: return {color: 'error', icon:'$warn', text: item.active };
            }
        },
        isItemIncomplete(item) {
            return item?.active == 'INCOMPLETE';
        }
    }
}